import { SET_ISTABLET, CLEAR_ISTABLET } from "../actions/type";

const INIT_STATE = {
  isTablet: false
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case SET_ISTABLET:
      return { ...state, isTablet: payload };
    case CLEAR_ISTABLET:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
